var map = {
	"./de-DE.json": [
		1791,
		2
	],
	"./en-GB.json": [
		1792,
		3
	],
	"./en-US.json": [
		1793,
		4
	],
	"./es-419.json": [
		1794,
		5
	],
	"./es-ES.json": [
		1795,
		6
	],
	"./fr-CA.json": [
		1796,
		7
	],
	"./fr-FR.json": [
		1797,
		8
	],
	"./id-ID.json": [
		1798,
		9
	],
	"./it-IT.json": [
		1799,
		10
	],
	"./ja-JP.json": [
		1800,
		11
	],
	"./nl-NL.json": [
		1801,
		12
	],
	"./pt-BR.json": [
		1802,
		13
	],
	"./zh-CN.json": [
		1803,
		14
	],
	"./zh-Hans-CN.json": [
		1804,
		15
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 843;
module.exports = webpackAsyncContext;